export class JsInitializer {
    constructor(name, init, properties, datasets) {
        this.name = name;
        this.inner = init;
        this.properties = properties;
        this.datasets = datasets;
    }
    apply() {
        const context = {
            globals: () => this.properties,
            data: () => this.datasets,
        };
        return this.inner(context);
    }
    updateProperties(props) {
        this.properties = props;
    }
}
//# sourceMappingURL=JsInitializer.js.map